import React, { useState } from 'react';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import './TextAreaComponents.css'

import { OutlinedInputProps } from '@mui/material/OutlinedInput';
import { InputAdornment } from '@mui/material';
function TextAreaComponents(props) {

    // const RedditTextField = styled((props: TextFieldProps) => (
    //     <TextField
    //         InputProps={{ disableUnderline: true } as Partial<OutlinedInputProps>}
    //         {...props}
    //     />
    // ))(({ theme }) => ({
    //     '& .MuiFilledInput-root': {
    //         overflow: 'hidden',
    //         borderRadius: 4,
    //         backgroundColor: theme.palette.mode === 'light' ? '#F3F6F9' : '#1A2027',
    //         border: '1px solid',
    //         borderColor: theme.palette.mode === 'light' ? '#E0E3E7' : '#2D3843',
    //         transition: theme.transitions.create([
    //             'border-color',
    //             'background-color',
    //             'box-shadow',
    //         ]),
    //         '&:hover': {
    //             backgroundColor: 'transparent',
    //         },
    //         '&.Mui-focused': {
    //             backgroundColor: 'transparent',
    //             boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
    //             borderColor: theme.palette.primary.main,
    //         },
    //     },
    // }));
    const handlecontactNumberChange = (event) => {

        try {
            const newValue = event.target.value;

            if (isNaN(newValue)) {

                var empty = newValue.slice(0, -1);

                // SetvalidPhoneNumber(false);
                props.value(empty);
            }
            else {
                if (newValue.length != 11) {
                    setPhoneError(true);
                }
                else {
                    setPhoneError(false)
                }
                props.value(newValue)
            }
        }
        catch {
            console.log("Error");
        }

    }

    const [phonerror, setPhoneError] = useState(false)
    const handlePhoneNumberChange = (event) => {
        const newValue = event.target.value;

        if (newValue.length != 10 && newValue.length != 11) {
            setPhoneError(true);
        }
        else {
            setPhoneError(false)
        }


        props.value(newValue);
    };

    const handleKeyDown = (event) => {
        // Prevent the minus sign (key code 189) from being entered
        if (event.keyCode === 189) {
            event.preventDefault();
        }
    };
    const handlePaste = (event) => {
        event.preventDefault();
    };
    const [textError, setTextError] = useState(false)
    const handletextChange = (event) => {
        const newValue = event.target.value;

        if (newValue.trim() === '') {
            setTextError(true)
        }
        else {
            setTextError(false)
        }


        props.value(newValue);
    };




    if (props.id === 1) {
        return (
            <>
                <TextField
                    id="outlined-multiline-static"
                    placeholder={props.label}
                    multiline
                    rows={3}
                    fullWidth
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        props.value(event.target.value);
                    }}
                    value={props.val}
                // sx={{ width: "100%" }}
                />
            </>

        );
    }
    else if (props.id === 2) {
        return (
            <TextField
                id="outlined-number"
                placeholder={props.label}
                type="number"
                fullWidth
                disabled={props.isactive}
                value={props.val}

                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    props.value(event.target.value);
                }}
                onKeyDown={handleKeyDown}
            />
        )

    }
    else if (props.id === 3) {
        return (
            <TextField
                id="outlined-number"
                placeholder={props.label}
                type="number"
                fullWidth
                disabled={props.isactive}
                value={props.val}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    props.value(event.target.value);
                }}
                InputProps={{ inputProps: { min: props.min, max: props.max } }} />
        )

    }
    else if (props.id === 4) {
        return (
            <TextField
                id="outlined-multiline-static"
                placeholder={props.label}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    props.value(event.target.value);
                }}
                size='small'
            // sx={{ width: "100%" }}
            />
        )

    }
    else if (props.id === 5) {
        return (
            <>
                <TextField id="outlined-basic" value={props.val} placeholder={props.label} label={props.label} variant="outlined" fullWidth onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    props.value(event.target.value);
                }} error={props.error} helperText={props.error ? 'This field is required' : ''} />
            </>
        );
    }
    // else if (props.id === 6) {
    //     <RedditTextField
    //         defaultValue="react-reddit"
    //         id="reddit-input"
    //         variant="filled"
    //         style={{ marginTop: 11 }}
    //         value={props.val}
    //         placeholder={props.label}
    //         label={props.label}
    //         fullWidth
    //         onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
    //             props.value(event.target.value);
    //         }}
    //     />
    // }
    else if (props.id == 6) {
        return (
            <>

                <TextField
                    id="outlined-basic"
                    value={props.val}
                    placeholder={props.label}
                    label={props.label}
                    variant="outlined"
                    fullWidth className='custom-textField'
                    // onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    //     props.value(event.target.value);
                    // }} 
                    onChange={handletextChange}
                    error={props.error ? props.error : props.isValid ? props.isValid : false}
                    helperText={props.error ? 'This field is required' : props.isValid ? 'Email is not valid' : ''}


                />

            </>
        );
    }
    else if (props.id == 7) {
        return (
            <>

                <TextField id="outlined-basic" value={props.val} placeholder={props.label} label={props.label} variant="outlined" fullWidth className='custom-textField selectedTextBox' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    props.value(event.target.value);
                }} />
                {/* <TextField id="outlined-basic" value={props.val} placeholder={props.label} variant="outlined"  fullWidth onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    props.value(event.target.value);
                }} /> */}
            </>
        );
    }
    else if (props.id === 8) {
        return (
            <>
                <TextField
                    id="outlined-multiline-static"
                    placeholder={props.label}

                    multiline
                    rows={3}
                    fullWidth
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        props.value(event.target.value);
                    }}
                    value={props.val}
                    label={props.label}
                    className='custom-textField custom-textArea'
                // sx={{ width: "100%" }}
                />
            </>

        );
    }
    else if (props.id === 9) {
        return (
            <TextField
                id="outlined-basic"
                placeholder={props.label}
                label={props.label}
                type="number"
                fullWidth
                disabled={props.isactive}

                value={props.val}
                className='custom-textField'
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    const newValue = event.target.value;

                    props.value(newValue);
                }}
                onKeyDown={handleKeyDown}
                error={props.error}
                helperText={props.error ? 'This field is required' : ''}

            />
        )

    }
    else if (props.id === 10) {
        return (
            <TextField
                id="outlined-number"
                placeholder={props.label}
                type="email"
                fullWidth
                disabled={props.isactive}
                value={props.val}

                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    props.value(event.target.value);
                }}
            />
        )

    }
    //phone number field for everyone except kyc-form
    else if (props.id === 11) {
        return (
            <TextField
                id="outlined-number"
                placeholder={props.label}
                type="number"
                fullWidth
                disabled={props.isactive}
                value={props.val}

                onChange={handlePhoneNumberChange}
                onKeyDown={handleKeyDown}
                error={phonerror}
                helperText={phonerror ? 'Number must be of 11 digits' : ''}
            />
        )

    }

    //phone number field for kyc form
    else if (props.id === 12) {
        return (
            <TextField
                id="outlined-basic"
                placeholder={props.label}
                label={props.label}
                type="number"
                fullWidth
                disabled={props.isactive}


                value={props.val}
                className='custom-textField'
                // onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                //     const newValue = event.target.value;

                //         props.value(newValue);                
                // }}
                // onKeyDown={handleKeyDown}
                onChange={handlePhoneNumberChange}
                onKeyDown={handleKeyDown}
                // error={props.error}
                // helperText={props.error ? 'This field is required' : ''}

                error={props.error ? true : phonerror}
                helperText={props.error ? 'Field is required' : phonerror ? 'Number must be of 10 or 11 digits' : ''}

            />
        )

    }
    //customized textfield of type text for phone number
    else if (props.id === 13) {
        return (
            <>
                <TextField id="outlined-basic"
                    value={props.val}
                    placeholder={props.label}
                    label={props.label}
                    variant="outlined"
                    fullWidth
                    className='custom-textField'
                    onChange={handlecontactNumberChange}
                    onKeyDown={handleKeyDown}
                    error={props.error ? true : phonerror}
                    helperText={props.error ? 'This field is required' : phonerror ? 'Number must be of 11 digits' : ''} />
            </>
        );
    }
    //email field of not pasteable
    else if (props.id == 14) {
        return (
            <>

                <TextField
                    id="outlined-basic"
                    type="email"
                    value={props.val}
                    placeholder={props.label}
                    label={props.label}
                    variant="outlined"
                    fullWidth className='custom-textField'

                    onChange={handletextChange}

                    error={props.isMatched ? props.isMatched : props.error}
                    helperText={props.isMatched ? 'Email not matched' : props.error ? 'This field is required' : ''}
                    onPaste={handlePaste}

                />

            </>
        );
    }

    else if (props.id === 15) {
        return (
            <>
                <TextField id="outlined-basic" disabled={true} value={props.val} placeholder={props.label} variant="outlined" fullWidth onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    props.value(event.target.value);
                }} error={props.error}
                    defaultValue={props.defaultValue}
                    helperText={props.error ? 'This field is required' : ''}
                />
            </>
        );
    }
    else {
        return (
            <>
                <TextField id="outlined-basic" value={props.val} placeholder={props.label} variant="outlined" fullWidth onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    props.value(event.target.value);
                }} error={props.error}
                    defaultValue={props.defaultValue}
                    helperText={props.error ? 'This field is required' : ''}
                />
            </>
        );
    }

}

export default TextAreaComponents;